import { render, staticRenderFns } from "./create-checklist-item.vue?vue&type=template&id=715f747e&scoped=true&"
import script from "./create-checklist-item.vue?vue&type=script&lang=js&"
export * from "./create-checklist-item.vue?vue&type=script&lang=js&"
import style0 from "./create-checklist-item.vue?vue&type=style&index=0&id=715f747e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f747e",
  null
  
)

export default component.exports